module.exports = __webpack_public_path__ + "img/512.f18e70f.png";